import {
    SET_APPROVAL_LIST_ASSIGNMENT,
    IS_APPROVAL_LIST_SAVED,
    SET_APPROVAL_LIST_EXCEL_DATA,
    SET_All_APPROVAL_LIST_EXCEL_DATA,
    IS_APPROVAL_LIST_VALIDATED,
    SET_ADDITIONAL_APPROVAL_LIST_ASSIGNMENT
} from "./ApprovalListAssignmentType"

const initialState = {
    approvalListAssignement: null,
    costCentersList: null,
}

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_APPROVAL_LIST_ASSIGNMENT:
            return {
                ...state,
                approvalListAssignement: action.response
            };
        case SET_ADDITIONAL_APPROVAL_LIST_ASSIGNMENT:
            return {
                ...state,
                additionalApprovalListAssignment: action.response
            };
        case IS_APPROVAL_LIST_SAVED:
            return {
                ...state,
                isApprovalListSaved: action.response
            };
        case IS_APPROVAL_LIST_VALIDATED:
            return {
                ...state,
                isApprovalListValidated: action.response
            };
        case SET_APPROVAL_LIST_EXCEL_DATA:
            return {
                ...state,
                approvalListExcelData: action.response
            };
        case SET_All_APPROVAL_LIST_EXCEL_DATA:
            return {
                ...state,
                allApprovalListExcelData: action.response
            };
        default:
            return state;
    }
};

export default reducer;